// import { lazy } from "react";

// // Authentication related pages
import Login from "../pages/Auth/index";
import Register from "../pages/Auth/register";
import EmployeeLogin from "../pages/Auth/employeeLogin";
import Landing from "../pages/Landing/index";
import UserDetails from "../pages/User-Details/index";
// const Landing = lazy(() => import("../pages/Landing/index"));
// const Register = lazy(() => import("../pages/Auth/register"));
// const UserDetails = lazy(() => import("../pages/User-Details/index"));

//Dashboard
import Dashboard from "../pages/Dashboard/index";
import Parties from "../pages/Parties/index";
import AddParties from "../pages/Parties/addParties";
import PartiesSelection from "../pages/Parties/partiesSelection";
import ItemsSelection from "../pages/Items/itemsSelection";
import NotFound from "../pages/NotFoundPage/index";
// const Dashboard = lazy(() => import("../pages/Dashboard/index"));
// const Parties = lazy(() => import("../pages/Parties/index"));
// const AddParties = lazy(() => import("../pages/Parties/addParties"));
// const NotFound = lazy(() => import("../pages/NotFoundPage/index"));

//Items
import Items from "../pages/Items/index";
// const Items = lazy(() => import("../pages/Items/index"));

//Settings
import AccountSettings from "../pages/Settings/index";
import ManageBusiness from "../pages/Settings/manage-business";
import ManageUsers from "../pages/Settings/manage-users";
import Reminders from "../pages/Settings/reminders";
import HelpSupport from "../pages/Settings/help-support";

// purchase

import SalesInvoice from "../pages/SalesInvoice/index";
import CreateSalesInvoice from "../pages/SalesInvoice/addSalesInvoice";

// purchase

import Vendor from "../pages/Vendor/index";
import AddVendor from "../pages/Vendor/addVendor";
import Purchase from "../pages/Purchase/index";
import CreatePurchase from "../pages/Purchase/addPurchase";
import PurchaseReturn from "../pages/PurchaseReturn/index";
import CreatePurchaseReturn from "../pages/PurchaseReturn/addPurchaseReturn";
import PurchaseOrders from "../pages/PurchaseOrders/index";
import CreatePurchaseOrders from "../pages/PurchaseOrders/addPurchaseOrders";

import PaymentOut from "../pages/PaymentOut/index";
import CreatePaymentOut from "../pages/PaymentOut/addPaymentOut";
import PaymentOutSelection from "../pages/PaymentOut/paymentSelection";
import PaymentIn from "../pages/PaymentIn/index";
import CreatePaymentIn from "../pages/PaymentIn/addPaymentIn";
import PaymentSelection from "../pages/PaymentIn/paymentSelection";
import DebitNote from "../pages/DebitNote/index";
import CreateDebitNote from "../pages/DebitNote/addDebitNote";

//Account solutions
import CashBank from "../pages/AccountSolutions/cash-bank";
import Expenses from "../pages/AccountSolutions/expenses-home";
import CreateExpenses from "../pages/AccountSolutions/addExpenses";
import ExpenseTransaction from "../pages/AccountSolutions/expense-transaction";
import ExpenseCategory from "../pages/AccountSolutions/expense-category";
import StockSummaryReport from "../pages/Items/stocksReport";
import VendorSelection from "../pages/Vendor/partiesSelection";
import PurchaseSelection from "../pages/PurchaseOrders/purchaseSelection";
import UserRole from "../pages/Settings/user-role";
import ActivityVouchers from "../pages/Settings/activity-vouchers";
import SalesInvoiceSelection from "../pages/SalesInvoice/salesInvoiceSelection";
import PurchaseInvoiceSelection from "../pages/Purchase/purchaseInvoiceSelection";
import PurchaseInvoiceImport from "../pages/Purchase/purchaseImport";
import SalesInvoiceImport from "../pages/SalesInvoice/salesImport";
import Reports from "../pages/Reports";
import LedgerStatement from "../pages/Reports/ledgerStatement";

//masters
import Grade from "../pages/Masters/grade";
import BrandDetails from "../pages/Masters/brand";
import RamDetails from "../pages/Masters/ram";

//reports
import StockDetailsReport from "../pages/Reports/stockDetailsReport";
import ItemQuantityReport from "../pages/Reports/itemQtyReport";
import ItemInvoiceImport from "../pages/Items/itemImport";
import BarcodeDetailsReport from "../pages/Reports/barcodeDetailsReport";
import SalesReturn from "../pages/SalesReturn";
import CreateSalesReturn from "../pages/SalesReturn/addSalesReturn";
import SalesReturnImport from "../pages/SalesReturn/salesImport";
import SalesInvoiceReturn from "../pages/SalesReturn/salesInvoiceReturn";
import SalesItemsQtyReport from "../pages/Reports/salesItemsQtyReport";
import SalesReport from "../pages/Reports/salesReport";
import SalesReturnReport from "../pages/Reports/salesReturnReport";
import SalesReturnItemsReport from "../pages/Reports/salesReturnItemsReport";
import PaymentInReport from "../pages/Reports/paymentInReport";
import PaymentOutReport from "../pages/Reports/paymentOutReport";
import SalesSummaryReport from "../pages/Reports/salesSummaryReport";
import PurchaseSummaryReport from "../pages/Reports/purchaseSummaryReport";
import PartyWiseOutstanding from "../pages/Reports/partyWiseOutstanding";
import CashInReport from "../pages/Reports/cashInReport";
import ExpensesReport from "../pages/Reports/expensesReport";
import ExpensesPreview from "../pages/AccountSolutions/expensesPreview";
import CustomerImport from "../pages/Parties/customerImport";
import PurchasePriceUpdate from "../pages/PurchasePriceUpdate";
import ProfitLossReport from "../pages/Reports/profitLossReport";

//Auth protected routes
const authProtectedRoutes = [
  { path: "/dashboard", exact: true, component: Dashboard },
  { path: "/not-found", exact: true, component: NotFound },
  { path: "/parties", exact: true, component: Parties },
  { path: "/add-parties", exact: true, component: AddParties },
  { path: "/parties/data", exact: true, component: PartiesSelection },
  {
    path: "/parties/import",
    exact: true,
    component: CustomerImport,
  },
  //items
  { path: "/items", exact: true, component: Items },
  { path: "/items/data", exact: true, component: ItemsSelection },
  {
    path: "/items/import",
    exact: true,
    component: ItemInvoiceImport,
  },
  { path: "/stock-summary-report", exact: true, component: StockSummaryReport },
  { path: "/settings/account", exact: true, component: AccountSettings },
  { path: "/settings/manage-business", exact: true, component: ManageBusiness },
  { path: "/settings/user-roles", exact: true, component: UserRole },
  {
    path: "/settings/activity-vouchers",
    exact: true,
    component: ActivityVouchers,
  },
  { path: "/settings/manage-users", exact: true, component: ManageUsers },
  { path: "/settings/reminders", exact: true, component: Reminders },
  { path: "/settings/help-support", exact: true, component: HelpSupport },
  //purchase

  { path: "/sales-invoice", exact: true, component: SalesInvoice },
  { path: "/create-sales-invoice", exact: true, component: CreateSalesInvoice },
  //purchase
  { path: "/vendor-supplier", exact: true, component: Vendor },
  { path: "/add-vendor-supplier", exact: true, component: AddVendor },
  { path: "/vendor/data", exact: true, component: VendorSelection },
  { path: "/purchase-invoice", exact: true, component: Purchase },
  { path: "/create-purchase-invoice", exact: true, component: CreatePurchase },
  { path: "/purchase-return", exact: true, component: PurchaseReturn },
  {
    path: "/purchase/price-update",
    exact: true,
    component: PurchasePriceUpdate,
  },
  {
    path: "/create-purchase-return",
    exact: true,
    component: CreatePurchaseReturn,
  },
  { path: "/purchase-orders", exact: true, component: PurchaseOrders },
  { path: "/purchase-orders/data", exact: true, component: PurchaseSelection },
  {
    path: "/sales-invoice/data",
    exact: true,
    component: SalesInvoiceSelection,
  },
  {
    path: "/sales-invoice/import",
    exact: true,
    component: SalesInvoiceImport,
  },
  { path: "/sales-return", exact: true, component: SalesReturn },

  {
    path: "/create-sales-return",
    exact: true,
    component: CreateSalesReturn,
  },
  {
    path: "/sales-return/data",
    exact: true,
    component: SalesInvoiceReturn,
  },
  {
    path: "/sales-return/import",
    exact: true,
    component: SalesReturnImport,
  },
  {
    path: "/purchase-invoice/data",
    exact: true,
    component: PurchaseInvoiceSelection,
  },
  {
    path: "/purchase-invoice/import",
    exact: true,
    component: PurchaseInvoiceImport,
  },
  {
    path: "/reports/barcode-items-report",
    exact: true,
    component: BarcodeDetailsReport,
  },

  {
    path: "/create-purchase-orders",
    exact: true,
    component: CreatePurchaseOrders,
  },
  { path: "/debit-note", exact: true, component: DebitNote },
  {
    path: "/create-debit-note",
    exact: true,
    component: CreateDebitNote,
  },
  { path: "/payment-out", exact: true, component: PaymentOut },
  { path: "/create-payment-out", exact: true, component: CreatePaymentOut },
  {
    path: "/payment-out/data",
    exact: true,
    component: PaymentOutSelection,
  },
  { path: "/payment-in", exact: true, component: PaymentIn },
  { path: "/create-payment-in", exact: true, component: CreatePaymentIn },
  {
    path: "/payment-in/data",
    exact: true,
    component: PaymentSelection,
  },
  //CashBank
  { path: "/cash-bank", exact: true, component: CashBank },
  { path: "/expenses", exact: true, component: Expenses },
  { path: "/create-expenses", exact: true, component: CreateExpenses },
  {
    path: "/expenses/data",
    exact: true,
    component: ExpensesPreview,
  },
  { path: "/expense-transaction", exact: true, component: ExpenseTransaction },
  { path: "/expense-category", exact: true, component: ExpenseCategory },

  //Reports
  { path: "/reports-dashboard", exact: true, component: Reports },
  {
    path: "/reports/party-ledger-statement",
    exact: true,
    component: LedgerStatement,
  },
  {
    path: "/reports/party-wise-outstanding",
    exact: true,
    component: PartyWiseOutstanding,
  },
  {
    path: "/reports/stock-details-report",
    exact: true,
    component: StockDetailsReport,
  },
  {
    path: "/reports/item-quantity-report",
    exact: true,
    component: ItemQuantityReport,
  },
  {
    path: "/reports/sales-item-quantity-report",
    exact: true,
    component: SalesItemsQtyReport,
  },
  {
    path: "/reports/sales-report",
    exact: true,
    component: SalesReport,
  },
  {
    path: "/reports/profit-loss-report",
    exact: true,
    component: ProfitLossReport,
  },
  {
    path: "/reports/sales-return-report",
    exact: true,
    component: SalesReturnReport,
  },
  {
    path: "/reports/sales-return-items-report",
    exact: true,
    component: SalesReturnItemsReport,
  },
  {
    path: "/reports/payment-in-report",
    exact: true,
    component: PaymentInReport,
  },
  {
    path: "/reports/payment-out-report",
    exact: true,
    component: PaymentOutReport,
  },
  {
    path: "/reports/sales-summary-report",
    exact: true,
    component: SalesSummaryReport,
  },
  {
    path: "/reports/purchase-summary-report",
    exact: true,
    component: PurchaseSummaryReport,
  },
  {
    path: "/reports/cash-in-report",
    exact: true,
    component: CashInReport,
  },
  {
    path: "/reports/expenses-report",
    exact: true,
    component: ExpensesReport,
  },

  //masters
  { path: "/settings/grade", exact: true, component: Grade },
  { path: "/settings/brand", exact: true, component: BrandDetails },
  { path: "/settings/ram", exact: true, component: RamDetails },
];

const publicRoutes = [
  // { path: "/logout", component: Logout },
  // { path: "/", exact: true, component: Login },
  { path: "/", exact: true, component: Landing },
  { path: "/login", component: Login },
  { path: "/employee-login", component: EmployeeLogin },
  { path: "/create-account", component: Register },
  { path: "/user-details", component: UserDetails },
  // { path: "/dashboard", component: Dashboard },
  // { path: "/forgot-password", component: ForgetPwd },
  // { path: "/otp-approve", component: OtpApprovePage },
];

export { authProtectedRoutes, publicRoutes };
